<template>
  <div v-if="isFetching" class="progress-center">
    <v-progress-circular class="ma-auto" :size="64" :width="6" indeterminate color="primary" />
  </div>
  <iframe
    v-else-if="dashboardUrl"
    :src="dashboardUrl"
    class="dashboard-container"
    allowtransparency
  ></iframe>
</template>

<script setup lang="ts">
import { useGetDashboardById } from '@/api/dashboards'
import { useRoute } from 'vue-router/composables'
import { computed } from 'vue'

const route = useRoute()
const dashboardId = computed(() => {
  if (route.name === 'new-metabase-dashboard') {
    return parseInt(route.params.id, 10)
  }
  return null
})

const { data: dashboardUrl, isFetching } = useGetDashboardById(dashboardId)
</script>

<style scoped>
.dashboard-container {
  width: 100%;
  height: 100%;
  display: block;
  border-width: 0;
}
</style>
